import { render } from "./SelectTime.vue?vue&type=template&id=729adddb&scoped=true"
import script from "./SelectTime.vue?vue&type=script&lang=js"
export * from "./SelectTime.vue?vue&type=script&lang=js"

import "./SelectTime.vue?vue&type=style&index=0&id=729adddb&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729adddb"]])

export default __exports__